<template>
  <div class="briefCard">
    <div class="image" :style="{'background-image':'url('+imageUrl+')'}"></div>
    <h1>
      {{ name }}
      <router-link :to="{ name: 'room', params: { id } }">
        more
        <i class="fas fa-chevron-right">&nbsp;</i>
      </router-link>
    </h1>
  </div>
</template>

<script>
export default {
  name: "briefCard",
  props: {
    id: {
      type: String,
      required: true
    },
    holidayPrice: {
      type: Number,
      required: false,
      default: 1500
    },
    normalDayPrice: { type: Number, required: false, default: 1380 },
    imageUrl: {
      type: String,
      required: false,
      default:
        "https://images.unsplash.com/photo-1551776235-dde6d482980b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80"
    },
    name: {
      type: String,
      required: false,
      default: "Single Room"
    }
  },
  computed: {
    routerName() {
      return this.name.split(" ").join("");
    }
  },
  methods: {
    selectRoom() {
      console.log("asd");
    }
  }
};
</script>

<style lang="scss" scoped>
.briefCard {
  min-width: 250px;
  width: 30%;
  flex-grow: 1;
  margin: var(--g-s);
  h1 {
    font-size: var(--fs-m);
    display: flex;
  }
  a {
    margin: 0;
    margin-left: auto;
    font-size: var(--fs-s);
    color: var(--text-color-lightest);
  }
}

.image {
  width: 100%;
  padding-top: 75%;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  margin-bottom: var(--g-m);
}
</style>
